import { Notyf } from "notyf";
import "notyf/notyf.min.css";

// Instancia global de Notyf con configuración predeterminada
const notyf = new Notyf({
  duration: 3000, // Duración predeterminada en milisegundos
  position: { x: "right", y: "bottom" }, // Posición de las notificaciones
});

const NotifyC = {
  success: (message, options = {}) => {
    notyf.open({
      type: "success",
      message,
      duration: options.duration !== undefined ? options.duration : 3000, // Duración personalizada o predeterminada
      ripple: options.ripple ?? true, // Opcional: efecto de onda
    });
  },
  error: (message, options = {}) => {
    notyf.open({
      type: "error",
      message,
      duration: options.duration !== undefined ? options.duration : 3000,
      ripple: options.ripple ?? true,
    });
  },
  warning: (message, options = {}) => {
    notyf.open({
      type: "warning",
      message,
      duration: options.duration !== undefined ? options.duration : 3000,
      ripple: options.ripple ?? true,
    });
  },
  info: (message, options = {}) => {
    notyf.open({
      type: "info",
      message,
      duration: options.duration !== undefined ? options.duration : 3000,
      ripple: options.ripple ?? true,
      background: options.background ?? "#2196F3", // Color de fondo personalizado
    });
  },
};

export default NotifyC;
